<template lang="html">
  <div id="candidate-profile-page" v-if="!loadingData">

    <section class="candidate-header-section" v-bind:style="{ backgroundImage: 'url('+postulate.usercompany.imageUrlBanner+')' }">

    </section>

    <section class="main-section">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-sidebar">
            <div class="content">

              <div class="box-user-info">
                <div class="box-image">
                  <div class="img" v-bind:style="{ backgroundImage: 'url('+postulate.usercompany.imageUrl+')' }"></div>
                </div>

                <div class="box-info">
                  <h5 class="mb-2">{{postulate.ciudad}}, {{postulate.estado}}.</h5>
                  <h5>{{postulate.usercompany.escolaridad}}</h5>
                  <h5>Sector: {{postulate.usercompany.area}}</h5>
                  <h5>Edad: {{postulate.usercompany.edad}} Años</h5>

                  <div class="mt-3 box-networks">
                    <h5 class="title">Perfiles sociales</h5>

                    <div class="row flex-center-xy mx-0">
                      <a class="trans-150 _btn-network fb" :href="postulate.usercompany.facebook" target="_blank"><i class="fab fa-facebook-f"></i></a>
                      <a class="trans-150 _btn-network tw" :href="postulate.usercompany.twitter" target="_blank"><i class="fab fa-twitter"></i></a>
                      <a class="trans-150 _btn-network ln" :href="postulate.usercompany.linkedin" target="_blank"><i class="fab fa-linkedin-in"></i></a>
                    </div>
                  </div>

                  <p class="mt-4">
                    <a class="btn-squ-cur-1 sm"  @click="savePostulate()">Guardar candidato</a>
                  </p>

                  <p class="mt-1">
                    <a class="mt-2 btn-squ-cur-1 sm whatsapp" target="_blank" :href="'https://wa.me/+52'+postulate.usercompany.telefono">Escribir por WhatsApp</a>
                  </p>

                  <p class="mt-4">
                    <a class="btn-squ-cur-1 blue-s2 lg" @click="downloadcv()">Descargar CV</a>
                  </p>
                </div>
              </div>

              <div class="box-contact-form">
                <h5 class="title">Formulario de contacto</h5>

                <b-form class="box-form" @submit="onSubmitContact">

                  <b-form-group class="col-12 custom-f-group-2" label="Nombre*" label-for="i-1">
                    <b-form-input
                      id="i-1"
                      v-model="formContact.nombre"
                      type="text"
                      placeholder="Ingresa tu nombre"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-12 custom-f-group-2" label="Correo electrónico*" label-for="i-2">
                    <b-form-input
                      id="i-2"
                      v-model="formContact.email"
                      type="email"
                      placeholder="Ingresa tu correo electrónico"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-12 custom-f-group-2" label="Numero telefónico*" label-for="i-3">
                    <b-form-input
                      id="i-3"
                      v-model="formContact.number"
                      type="text"
                      placeholder="Ingresa tu número telefónico"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-12 custom-f-group-2" label="Mensaje*" label-for="i-4">
                    <b-form-textarea
                      id="i-4"
                      v-model="formContact.msg"
                      placeholder="Escriba el mensaje aquí"
                      rows="4"
                      max-rows="4"
                    ></b-form-textarea>
                  </b-form-group>

                  <div class="col-12">
                    <b-form-checkbox class="accept-checkbox"
                      v-model="formContact.check"
                      name="checkbox-1"
                      value="accepted"
                      :unchecked-value="null"
                      required>
                      Al hacer clic en la casilla de verificación, acepta nuestros <router-link to="">Términos y condiciones</router-link> y <router-link to="">Política de privacidad</router-link>
                    </b-form-checkbox>
                  </div>

                  <div class="col-12 mt-3">
                    <b-button type="submit" class="btn-squ-cur-1 blue lg">Enviar Mensaje</b-button>
                  </div>

                </b-form>
              </div>

            </div>
          </div>

          <div class="col-lg-9 col-page-content">
            <div class="b">
              <div class="row">

                <div class="col-12 px-0 px-lg-3">
                  <div class="box-bubble">
                    <div class="row">

                      <div class="col-12 box-acc-title-s1">
                        <h4>{{postulate.usercompany.nombre}}</h4>
                        <hr />
                      </div>

                      <!-- Basic Info -->
                      <section class="col-12 basic-info-section">
                        <div class="col-12 col-sm col-info">
                          <h5 class="m-title">Nivel académico</h5>
                          <h5 class="res">{{postulate.usercompany.escolaridad}}</h5>
                        </div>

                        <div class="col-12 col-sm col-info">
                          <h5 class="m-title">Último curso</h5>
                          <h5 class="res">-</h5>
                        </div>

                        <div class="col-12 col-sm col-info">
                          <h5 class="m-title">Sueldo deseado</h5>
                          <h5 class="res">$ {{postulate.usercompany.sueldodeseado}}</h5>
                        </div>
                      </section>
                      <!--  -->

                      <!-- CV -->
                      <section class="cv-section">
                        <div class="col-12 box-sec-title">
                          <div class="col px-3 px-sm-0 col-title">
                            <h5 class="title">Descripción</h5>
                          </div>
                        </div>

                        <div class="col-12 box-gral-info">
                          <div class="row">
                            <div class="col col-info">
                              <div>
                                <p v-html="postulate.usercompany.cv">
                                  
                                </p>
                               
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!--  -->

                      <!-- Educación -->
                      <section class="cv-section">
                        <div class="col-12 box-sec-title">
                          <div class="col col-icon">
                            <img src="public/images/pages/account/cv-icon-education.png">
                          </div>
                          <div class="col col-title">
                            <h5 class="title">Educación</h5>
                            <hr class="sep" />
                          </div>
                        </div>

                        <div class="col-12 box-table-info" v-for="(edu, eduInx) in postulate.cv.educations" :key="'eduInx-'+eduInx">
                          <div class="row">
                            <div class="col col-years">
                              <h6>{{edu.desde}} - {{edu.hasta}}</h6>
                            </div>

                            <div class="col col-info">
                              <ul>
                                <li>{{edu.institucion}}</li>
                              </ul>

                              <h5 class="title">{{edu.formacion}}</h5>
                              <p class="descr">{{edu.descripcion}} </p>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!--  -->

                      <!-- Experiencia Laboral -->
                      <section class="cv-section">
                        <div class="col-12 box-sec-title">
                          <div class="col col-icon">
                            <img src="public/images/pages/account/cv-icon-experience.png">
                          </div>
                          <div class="col col-title">
                            <h5 class="title">Experiencia Laboral</h5>
                            <hr class="sep" />
                          </div>
                        </div>

                        <div class="col-12 box-table-info" v-for="(exp, expInx) in postulate.cv.experiences" :key="'expInx-'+expInx">
                          <div class="row">
                            <div class="col col-years">
                             <h6>{{exp.desde}} - {{exp.hasta}}</h6>
                            </div>

                            <div class="col col-info">
                              <ul>
                                <li>{{exp.empresa}}</li>
                              </ul>

                              <h5 class="title">{{exp.puesto}}</h5>
                              <p class="descr">{{exp.descripcion}}</p>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!--  -->

                      <!-- Portafolio laboral -->
                      <section class="cv-section">
                        <div class="col-12 box-sec-title">
                          <div class="col col-icon">
                            <img src="public/images/pages/account/cv-icon-portfolio.png">
                          </div>
                          <div class="col col-title">
                            <h5 class="title">Portafolio laboral</h5>
                            <hr class="sep" />
                          </div>
                        </div>

                        <div class="col-12 box-portfolio">
                          <div class="row">
                            <div class="col-6 col-sm-4 col-md-3 col-xl-2 col-portfolio-file" v-for="(prtf, prFilInx) in postulate.cv.briefcase" :key="'prFilInx-'+prFilInx">
                              <div class="box-image">
                                <a class="trans-150" :href="prtf.documentUrl" target="_blank">
                                  <img src="public/images/pages/account/img-prev-file.png">
                                </a>
                              </div>

                              <div class="box-inf">
                                <h6>{{prtf.titulo}}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!--  -->

                      <!-- Logros destacados -->
                      <section class="cv-section">
                        <div class="col-12 box-sec-title">
                          <div class="col col-icon">
                            <img src="public/images/pages/account/cv-icon-achievements.png">
                          </div>
                          <div class="col col-title">
                            <h5 class="title">Logros destacados</h5>
                            <hr class="sep" />
                          </div>
                        </div>

                        <div class="col-12 box-table-info" v-for="(arch, logInx) in postulate.cv.achievements" :key="'logInx-'+logInx">
                          <div class="row">
                            <div class="col col-years">
                              <h6>10-12-2015</h6>
                            </div>

                            <div class="col col-info">
                              <h5 class="title">{{arch.titulo}}</h5>
                              <p class="descr">{{arch.descripcion}}</p>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="col-12 box-table-info">
                          <div class="row">
                            <div class="col-12 py-3 text-center">
                              <h6 class="f-w-600">No tiene ningun elemento agregado aquí</h6>
                            </div>
                          </div>
                        </div> -->
                      </section>
                      <!--  -->

                      <!-- Idiomas -->
                      <section class="cv-section">
                        <div class="col-12 box-sec-title">
                          <div class="col col-icon">
                            <img src="public/images/pages/account/cv-icon-languages.png">
                          </div>
                          <div class="col col-title">
                            <h5 class="title">Idiomas</h5>
                            <hr class="sep" />
                          </div>
                        </div>

                        <div class="col-12 box-table-info" v-for="(lang, idmInx) in postulate.cv.languages" :key="'idmInx-'+idmInx">
                          <div class="row">
                            <div class="col col-years">
                              <h6 class="txt-xl">{{lang.procentaje}}%</h6>
                            </div>

                            <div class="col col-info col-lang">
                              <h5 class="title">{{lang.idioma}}</h5>
                            </div>
                          </div>
                        </div>
                      </section>
                      <!--  -->

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="comments-section">

      <!-- Comentario (formulario) -->
      <div class="container box-comments-form" id="form_califications">
        <div class="row">
          <div class="offset-lg-3 col-lg-9">
            <div class="box-el-title">
              <h3>Deja tu opinión</h3>
            </div>

            <div class="row">
              <div class="col-12 content">
                <b-form class="box-form-comment" @submit="onSubmit">

                  <div class="box-form-group-1">
                    <div class="row align-items-center">
                      <div class="col-sm-6 col-md-7 col-stars">
                        <div class="box-category">
                          <label for="rating-inline">Calificación</label>
                          <b-form-rating id="rating-inline" inline v-model="formRating.calification"></b-form-rating>
                        </div>

                       <!--  <div class="box-category">
                          <label for="rating-inline">Trato al personal</label>
                          <b-form-rating id="rating-inline" inline v-model="formRating.trato"></b-form-rating>
                        </div>

                        <div class="box-category">
                          <label for="rating-inline">Compromiso</label>
                          <b-form-rating id="rating-inline" inline v-model="formRating.compromiso"></b-form-rating>
                        </div> -->
                      </div>

                      <div class="col-sm-6 col-md-5 col-score">
                        <h6>Calificación General</h6>
                        <h3>{{formRating.calification}}</h3>
                      </div>
                    </div>
                  </div>

                  <div class="box-form-group-2">
                    <b-form-group>
                      <b-form-textarea
                        v-model="formRating.msg"
                        placeholder="Tu experiencia con la empresa"
                        rows="4"
                        max-rows="4"
                        required
                      ></b-form-textarea>
                    </b-form-group>
                  </div>

                  <div class="box-form-group-3">
                    <b-button type="submit" class="btn-squ-cur-1 lg blue">Comentar</b-button>
                  </div>

                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- Comentarios posteados -->
      <section class="container box-comments" id="calification_company">
        <div class="row">
          <div class="offset-lg-3 col-lg-9">
            <div class="box-el-title">
              <h3>Opiniones</h3>
            </div>

            <div class="row">
              <div class="col-12 content">
                <div class="box-comment-sample-s1" v-for="(calification, indxc) in postulate.calfications" :key="indxc">
                  <div class="col col-photo">
                    <div class="placed-backg img show-full" v-bind:style="{ backgroundImage: 'url('+calification.empresa_imageUrl+')' }"></div>
                  </div>

                  <div class="col col-info">
                    <div class="box-date">{{calification.fecha}}</div>
                    <h4>{{calification.empresa}}</h4>

                    <div class="box-stars" v-if="calification.calificacion == 5">
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                    </div>
                    <div class="box-stars" v-else-if="calification.calificacion == 4">
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                    </div>
                    <div class="box-stars" v-else-if="calification.calificacion == 3">
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                    </div>
                    <div class="box-stars" v-else-if="calification.calificacion == 2">
                      <i class="fas fa-star star"></i>
                      <i class="fas fa-star star"></i>
                    </div>
                    <div class="box-stars" v-else-if="calification.calificacion == 1">
                      <i class="fas fa-star star"></i>
                    </div>

                    <div class="box-descr">
                      {{calification.msg}}
                    </div>
                    <div class="box-descr" v-if="calification.respuesta != null">
                      <b>- Respuesta: </b> {{calification.respuesta}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--  -->
      <sweet-modal :icon="modal.icon" ref="modalAlert">
          {{modal.msg}}
      </sweet-modal>
      <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
      </sweet-modal>
   

    </section>

  </div>
  <div v-else style="text-align: center;">
      <img src="/public/images/shared/loading.gif" style="width: 200px;">
  </div>
  
</template>

<script>
export default {
  data(){
    return{
      formContact: {
        nombre: null,
        usuarios_id:null,
        msg:null,
      },

      formRating: {
        calification: null,
        msg:null,
        usuarios_id:null
      },
      modal:{
          icon:null,
          msg:null
      },

      califications: [
        { usuario_image: 'public/images/pages/jobs/logo-1.png', fecha: '20-Oct-2021', usuario : 'Insumos Quirurgicos de Occidente', calificacion: 5, msg: 'Esto es una opinión de prueba.', respuesta: 'Esto es una respuesta de prueba también.' },
        { usuario_image: 'public/images/pages/jobs/logo-5.png', fecha: '19-Oct-2021', usuario : 'Intra Lasik', calificacion: 5, msg: 'Esto es una opinión de prueba. Lorem elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in velit esse cillum dolore eu fugiat null.', respuesta: 'Esto es una respuesta de prueba también.' },
      ],
      id:null,
      postulate:{},
      loadingData:true
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (this.$root.logged == true) {
          if (this.$root.type_logged == 'empresa') {
              
              this.formRating.usuarios_id = this.id;
              this.formRating.empresa_id = this.$root.user.usercompany.id;
              axios.post(tools.url("/postulateFrontStoreCalification"),this.formRating)
                .then((response)=>{
                    this.getData();
                      this.formRating.calification = 0;
                      this.formRating.msg = null;

                      this.modal.icon = 'success'
                      this.modal.msg = 'Calificación guardada con exito';
                      this.$refs.modalAlert.open();
                  }).catch((error)=>{
                      this.modal.icon = 'error'
                      this.modal.msg = 'Ocurrio un error al guardar';
                      this.$refs.modalAlert.open();
                  });
          }
          else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes dejar comentarios hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }
      }
      else{
        this.modal.icon = 'warning';
        this.modal.msg = 'No puedes dejar comentarios hasta estar registrado o haber iniciado sesion';
        this.$refs.modalAlert.open();
      }

    },
    onSubmitContact(event){
       event.preventDefault();
       if (this.$root.logged == true) {
          if (this.$root.type_logged == 'empresa') {
        
            this.formContact.usuarios_id = this.id;
            this.formContact.empresa_id = this.$root.user.usercompany.id;
            axios.post(tools.url("/postulateFrontStoreMsg"),this.formContact)
              .then((response)=>{
                    this.formContact = {};

                    this.modal.icon = 'success'
                    this.modal.msg = 'Gracias, su mensaje ha sido enviado!';
                    this.$refs.modalAlert.open();
                }).catch((error)=>{
                    this.modal.icon = 'error'
                    this.modal.msg = 'Ocurrio un error al guardar!';
                    this.$refs.modalAlert.open();
                });
          }
          else{
              this.modal.icon = 'warning';
              this.modal.msg = 'No puedes contactar a la empresa hasta estar registrado o haber iniciado sesion';
              this.$refs.modalAlert.open();
          }
      }
      else{
        this.modal.icon = 'warning';
        this.modal.msg = 'No puedes contactar a la empresa hasta estar registrado o haber iniciado sesion';
        this.$refs.modalAlert.open();
      }
    },
    getData(){
        axios.get(tools.url("/getPostulateCv/"+this.id))
        .then((response)=>{
              this.loadingData = false;
              this.postulate = response.data;
            
          }).catch((error)=>{
            this.loadingData = false;
               this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al obtener la información';
              this.$refs.modalAlert.open();
          });
    },
    downloadcv(){
          axios.get(tools.url("/downloadCvPostulate/"+this.id)).then((response)=>{
              
              window.open(response.data,'_blank');
          }).catch(()=>{});
      },
      savePostulate(){
            var data = {
              'usuarios_id':this.id,
              'vacant_id':null
            };
           axios.post(tools.url("/api/admin/saveFavoritePostulateFront"),data).then((response)=>{
              this.$root.auth();
              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Candidato guardado correctamente';
              this.$refs.modalAlert.open();


          }).catch((error)=>{
            if(error.response.data.status == 'yaexiste'){
                this.$refs.modalLoading.close();
                this.modal.icon = 'warning';
                this.modal.msg = error.response.data.msg;
                this.$refs.modalAlert.open();
            }
            else{
                this.$refs.modalLoading.close();
                this.modal.icon = 'error';
                this.modal.msg = 'Ocurrio un error al guardar la información';
                this.$refs.modalAlert.open();
            }
              

          });
      },
  },
  mounted(){
      if(this.$route.params.id){
           this.id = this.$root._getURLID(this.$route.params.id);
          this.getData();
      }
  }
}
</script>
